var _style, _g, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcono2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 689.9 563.2",
    style: {
      enableBackground: "new 0 0 689.9 563.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A3DDB5;}\r\n\t.st1{fill:#36504B;}\r\n\t.st2{fill:#B0F7D5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.4,
    cy: 68,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 140.9,
    cy: 20.3,
    r: 20.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 72.8,
    cy: 174.4,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 565.1,
    cy: 450.3,
    r: 23.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 661,
    cy: 410.3,
    r: 28.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -197.1799 592.5656)",
    className: "st0",
    cx: 616.7,
    cy: 534.3,
    rx: 28.9,
    ry: 28.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M595.9,61.6c-2.8-4.1-7.4-6.5-12.4-6.5h-51c0.3-4.6,0.7-9.3,1-13.9c0.3-4.2-1.1-8.2-4-11.3 c-2.8-3-6.8-4.8-11-4.8h-204c-4.2,0-8.1,1.7-11,4.8c-2.9,3.1-4.3,7.1-4,11.3c1.7,23.2,13.6,188,13.6,188l1.7,22.9H309 c-24.7,0-48.1,10.9-64,30c-5,6-11.3,9-19.2,9h-16.3v-6.5c0-8.3-6.7-15-15-15h-88c-8.3,0-15,6.7-15,15v225.5c0,8.3,6.7,15,15,15h88 c8.3,0,15-6.7,15-15v-12h16.3c7.9,0,14.1,2.9,19.2,9c16,19.1,39.3,30,64,30h209.6c24.8,0,45-20.2,45-45c0-11.5-4.4-22-11.5-30 c7.1-8,11.5-18.5,11.5-30s-4.4-22-11.5-30c7.1-8,11.5-18.5,11.5-30s-4.4-22-11.5-30c7.1-8,11.5-18.5,11.5-30 c0-23-17.4-42.1-39.7-44.7l73.6-191.9C599.3,70.9,598.7,65.7,595.9,61.6L595.9,61.6z M533.6,372.1c0,8.3-6.7,15-15,15h-53.9 c2.3-5.9,3.6-12.5,3.6-20v-10h50.2C526.9,357.1,533.6,363.8,533.6,372.1z M533.6,432.1c0,8.3-6.7,15-15,15h-51.1 c-8.3,0-15-6.7-15-15s6.7-15,15-15h51.1C526.9,417.1,533.6,423.8,533.6,432.1z M449.9,267.1c-10.1-9.3-23.7-15-38.5-15h-65.9 c0-26.6,32.5-49,71-49s71,22.4,71,49c0,1.2-0.4,15-0.4,15H449.9z M499.7,91.8c-16.5-6-29.3-19.8-34.1-36.7h36.8 C501.5,67.3,500.6,79.5,499.7,91.8z M434.8,55.1c2.8,16,10.2,30.9,21.4,42.9c11.2,12.1,25.5,20.5,41.3,24.5 c-1.9,25.7-3.7,51.3-5.6,77c-1.8-1.6-3.7-3.1-5.7-4.6c-18.8-14-43.6-21.7-69.7-21.7s-50.9,7.7-69.7,21.7c-2,1.5-3.9,3-5.7,4.6 c0,0-5.1-70.2-5.6-77c15.7-4,30.1-12.4,41.3-24.4c11.2-12.1,18.5-27,21.4-43H434.8L434.8,55.1z M367.4,55.1 c-4.8,16.9-17.6,30.6-34.1,36.7c-0.9-12.2-1.8-24.5-2.6-36.7L367.4,55.1z M179.5,495.1h-58V299.6h58V495.1z M268,487.8 c-10.8-12.9-25.4-19.7-42.2-19.7h-16.3v-147h16.3c16.8,0,31.4-6.8,42.2-19.7c10.3-12.3,25.2-19.3,41-19.3h102.4 c14.9,0,27,12.1,27,27v58c0,20.2-19.7,20.8-21.9,20.8s-21.9-0.6-21.9-20.8v-36c0-8.3-6.7-15-15-15s-15,6.7-15,15v12 c0,27.7-22.5,50.2-50.2,50.2h-21.8c-8.3,0-15,6.7-15,15s6.7,15,15,15h21.8c23.5,0,44.7-10.2,59.4-26.3c2.2,3.1,4.7,5.9,7.6,8.3 c9.4,8.1,21.9,12.6,35.2,12.6c2.9,0,5.8-0.2,8.6-0.7c-1.6,4.6-2.5,9.6-2.5,14.8c0,11.5,4.4,22,11.5,30c-7.1,8-11.5,18.5-11.5,30 c0,5.3,0.9,10.3,2.6,15H309C293.2,507.1,278.2,500.1,268,487.8L268,487.8z M518.6,507.1h-51.1c-8.3,0-15-6.7-15-15s6.7-15,15-15 h51.1c8.3,0,15,6.7,15,15S526.9,507.1,518.6,507.1z M533.6,312.1c0,8.3-6.7,15-15,15h-50.2v-18c0-4.1-0.4-8.1-1.3-12h51.5 C526.9,297.1,533.6,303.8,533.6,312.1z M523,186c1.8-24.6,7-96.8,7.3-100.9h31.4L523,186z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.5,299.6h58c-12.8,25.2-26.4,56.5-37.5,93.5c-11.5,38.4-17.5,73.2-20.5,102 C121.5,429.9,121.5,364.8,121.5,299.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M155,415.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono2);
export default __webpack_public_path__ + "static/media/icono2.92f44ea4c120f30a90f3c32c13b73e8a.svg";
export { ForwardRef as ReactComponent };